import { inject, Injectable } from "@angular/core";
import { Translation, TranslocoLoader } from "@jsverse/transloco";
import { HttpClient, HttpContext, HttpHeaders } from "@angular/common/http";
import { BYPASS_BASE_URL } from "core";
import { forkJoin, map } from 'rxjs';

// Ridefinito causa impossibilità di import
type TranslocoLoaderData = {
    scope: string;
};

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private http = inject(HttpClient);

    getTranslation(lang: string, data?: TranslocoLoaderData) {
        const language = lang.split('/').pop()!;
        // Percorsi relativi al base href: l'app puo' stare anche in una virtual directory (es. /frontend-dev/)
        if (data?.scope) {
            return this.loadCatalogue(`assets/${data.scope}/i18n/${language}.json`);
        }

        // Core e design system sono condivisi anche dalle pagine di accesso.
        // I cataloghi restano nei rispettivi progetti; le feature usano gli scope lazy.
        return forkJoin({
            app: this.loadCatalogue(`assets/i18n/${language}.json`),
            core: this.loadCatalogue(`assets/core/i18n/${language}.json`),
            designSystem: this.loadCatalogue(`assets/design-system/i18n/${language}.json`),
        }).pipe(map(({ app, core, designSystem }) => ({ ...app, core, designSystem })));
    }

    // I cataloghi non hanno l'hash nel nome: il browser li ricontrolla sempre, cosi' dopo un rilascio arrivano le chiavi nuove
    private loadCatalogue(url: string) {
        return this.http.get<Translation>(url, {
            headers: new HttpHeaders({ 'Cache-Control': 'no-cache' }),
            context: new HttpContext().set(BYPASS_BASE_URL, true)
         });
    }
}
